import {Notification} from "../Notification";
import React, {useContext, useState} from "react";
import {FormContext} from "../../context/form/formContext";
import {ValidateEmail} from "../../helpers/validations";
import {invalidEmail} from "../../constants/messages";
import {contactFormsIds} from "../../constants/api";
import '../../scss/contact_form.scss'
import {ContactForm} from "../ContactForm";

const ContactFormWrapper = () => {
    const initialData = {
        your_name: "",
        your_email: "",
        your_message: "",
    };

    const { sendContactForm } = useContext(FormContext);
    const [errors, setMessage] = useState({});
    const [userData, setData] = useState({ ...initialData });

    const changeData = (e) => {
        setMessage({
            ...errors,
            [e.target.name]: "",
        });

        setData({
            ...userData,
            [e.target.name]: e.target.value,
        });
    };

    const sendForm = (e) => {
        e.preventDefault();

        const errorsObj = {};

        for (var field in userData) {
            if (userData[field] === "") {
                errorsObj[field] = `${field
                    .split("_")[1]
                    .toLocaleLowerCase()} can't be empty!`;
            }
        }

        if (!ValidateEmail(userData["your_email"])) {
            errorsObj["your_email"] = invalidEmail;
        }

        if (
            !errorsObj.hasOwnProperty("your_name") &&
            !errorsObj.hasOwnProperty("your_email")
        ) {
            sendContactForm(userData, contactFormsIds.contactUs);
            setData({ ...initialData });
        } else {
            setMessage(errorsObj);
        }
    };
    return(
        <section className="main_contacts">
            <div className="container">
                <div className="contacts_inner">
                    <div className="inner_row">
                        <div className="contacts_content">
                            <h3>Contact Us</h3>
                            <p>
                                Our team is always available to answer your questions and
                                provide additional information about our services. On our
                                website, you'll also find a wealth of resources, including
                                case studies of previous projects and clients, to give you a
                                better understanding of our experience and capabilities.
                            </p>
                            <p>
                                We look forward to helping you achieve success with your
                                business idea.
                            </p>
                        </div>
                        <ContactForm
                            sendForm={sendForm}
                            changeData={changeData}
                            errors={errors}
                            userData={userData}
                        />
                    </div>
                </div>
            </div>
            <Notification />
        </section>
    )
}


export default ContactFormWrapper